import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError, from } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { AuthService } from './auth.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private authService: AuthService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Skip interceptor for assets and auth endpoints that don't require authentication
    if (req.url.includes('/assets') ||
        req.url.includes('/auth/check-login') ||
        req.url.includes('/auth/forgot-password') ||
        req.url.includes('/auth/request-reset') ||
        req.url.includes('/auth/reset-password')) {
      return next.handle(req);
    }

    // Handle async getToken
    return from(this.authService.getToken()).pipe(
      switchMap(token => {
        if (token) {
          req = req.clone({
            setHeaders: {
              Authorization: `Bearer ${token}`
            }
          });
        }

        return next.handle(req).pipe(
          catchError((error: HttpErrorResponse) => {
            if (error.status === 401) {
              // Try to refresh token
              return from(this.authService.refreshToken()).pipe(
                switchMap((refreshed) => {
                  if (refreshed) {
                    return from(this.authService.getToken()).pipe(
                      switchMap(newToken => {
                        if (newToken) {
                          const newReq = req.clone({
                            setHeaders: {
                              Authorization: `Bearer ${newToken}`
                            }
                          });
                          return next.handle(newReq);
                        }
                        // If no new token, logout
                        this.authService.logout();
                        return throwError(error);
                      })
                    );
                  }
                  // If refresh failed, logout
                  this.authService.logout();
                  return throwError(error);
                }),
                catchError(() => {
                  this.authService.logout();
                  return throwError(error);
                })
              );
            }
            return throwError(error);
          })
        );
      })
    );
  }
}